import { useMemo } from "react";
import { axiosInstance } from "../../utils";

export function useWageImportTemplate() {
    const axios = axiosInstance();

    return useMemo(
        () => (clientId: string | undefined, progressCallback: (progress: number) => void) =>
            axios
                .get<Blob>(`api/clients/${clientId}/wagejobs/template`, {
                    responseType: "blob",
                    onDownloadProgress: progressEvent => {
                        const loaded = progressEvent.loaded;
                        const total = progressEvent.total;
                        if (total) {
                            const percentage = (loaded / total) * 100;
                            progressCallback(percentage);
                        }
                    },
                })
                .then(response => {
                    const contentDisposition = response.headers["content-disposition"];
                    let contentFilename;

                    if (contentDisposition) {
                        const match = contentDisposition.match(/filename="?([^"]+)"?/);

                        if (match) {
                            contentFilename = match[1];
                        }
                    }
                    return {
                        data: response.data,
                        filename: contentFilename || "wage-import-template.csv",
                    };
                }),
        [axios]
    );
}
